// Get field options and separate them with alf separator
import { is, isEmpty } from 'ramda';

export const getOptions = (params: any) => {
  if (params?.options) {
    return Array.isArray(params.options)
      ? params.options
      : params.options.split('#alf#').map((it: string) => ({
          value: it.split('|')[0],
          label: it.split('|')[1],
        }));
  } else {
    return null;
  }
};

// Get final value to show in view select mode
export const getSimpleSelectValue = (value: any, params: any) => {
  const options = getOptions(params);

  if (!value || isEmpty(value)) {
    return window.Alfresco.messages.global['label.none'];
  }

  if (is(Array, value)) {
    if (value.length < 1) {
      return window.Alfresco.messages.global['label.none'];
    }
    // If options exist, find options where it's value is same as field value, then get it's label and join them by coma;
    if (options) {
      return value.map((it: string) => options.find((optIt: any) => optIt.value === it)?.label).join(', ');
    }
    return value.map((item: any) => item?.label || item).join(', ');
  }

  if (options) {
    return options.find((it: any) => it.value === value || it.value === value?.value)?.label;
  }

  return value?.label || value || window.Alfresco.messages.global['label.none'];
};

export const getValue = (value: any, options: any) =>
  !value ? null : Array.isArray(value) || value.value ? value : options.find(item => item.value === value) || null;
